<template>
	<div v-if="isFewItems">
		<span>{{ successMountpointsCount }} {{ $t('paas.mountpointsDisplay.stations', count) }}</span>
		{{ mountpointsList }}
	</div>
	<div v-else>
		<span class="dotted" @click="toggle">{{ successMountpointsCount }} {{ $t('paas.mountpointsDisplay.stations', count) }}</span>
		{{ isExpanded ? mountpointsList : mountpointsListTrimmed }}
	</div>
</template>

<script>
import { ref, toRef, computed } from 'vue';

export default {
	props: ['mountpoints', 'successMountpointsCount'],
	setup(props) {
		const MAX_ITEMS = 10;
		const mountpointsRef = toRef(props, 'mountpoints');
		const isExpanded = ref(false);
		const isFewItems = computed(() => mountpointsRef.value.length <= MAX_ITEMS);
		const count = computed(() => mountpointsRef.value.length);
		const mountpointsList = computed(() => mountpointsRef.value.join(', '));
		const mountpointsListTrimmed = computed(() => mountpointsRef.value.slice(0, MAX_ITEMS).join(', ') + '...');

		const toggle = () => {
			isExpanded.value = !isExpanded.value;
		};
		return {
			isExpanded,
			isFewItems,
			count,
			mountpointsList,
			mountpointsListTrimmed,
			toggle,
		};
	},
}
</script>

<style scoped></style>
